import React from 'react'

import { Center, Icon } from '.'

export const Offline = () => (
  <Center>
    <Icon name="signal_wifi_off" />
  </Center>
)
